import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

export interface SubscriptionData {
  id: string;
  external_id: string;
  status: string;
  quantity: number;
  tenant_id: string;
  term_start_date: string | null;
  term_end_date: string | null;
  term_unit: string | null;
  payload: any;
  created_at: string;
  updated_at: string;
}

/**
 * Fetches the marketplace subscription for a given tenant
 */
export async function fetchSubscription(tenantId: string): Promise<SubscriptionData | null> {
  try {
    const { data, error } = await supabase
      .from('msmp_subscriptions')
      .select('*')
      .eq('tenant_id', tenantId)
      .single();

    if (error) {
      // If no subscription found, return null (not an error state)
      if (error.code === 'PGRST116') {
        return null;
      }
      throw error;
    }

    return data;
  } catch (error: any) {
    console.error("Error fetching subscription:", error);
    toast({
      title: "Error",
      description: "Failed to load subscription data",
      variant: "destructive",
    });
    throw error;
  }
}


